module.exports = __webpack_public_path__ + "static/media/g2.cd783079.png";